import { useEditorContext } from "../EditorContext";
import { getFormLableStyleObj } from "../FormText/FormBaseStyle";

function mergeLabelStyle(base, custom) {
  const merged = { ...base };
  for (const key in custom) {
    const value = custom[key];
    // This is the crucial condition:
    if (value !== undefined && value !== null && value !== '') {
      merged[key] = value;
    }
  }
  return merged;
}

export default ({ data, customLabelStyle }) => {
  const { hideLabel, required, label: originalLabel } = data;
  const label = typeof originalLabel === "string" ? originalLabel.trimStart() : originalLabel || "";
  const { state } = useEditorContext();
  const lableStyle = getFormLableStyleObj(state.root.data);
  const style = mergeLabelStyle({ display: "flex", ...lableStyle }, customLabelStyle || {});
  return (
    !hideLabel && (
      <label style={style}>
        {required && <span style={{ color: "#ff4d4f", marginRight: 4 }}>*</span>}
        {label}
      </label>
    )
  );
};
